var exports = {
  "o": "ForumPostActions.module__actions___RHRtTm",
};

module.exports = exports;
